var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Cacheable } from "../../../../lib/cache/cacheable.cls";
import { Process } from "../../../../lib/process/process.cls";
var FifoCache = /** @class */ (function (_super) {
    __extends(FifoCache, _super);
    /**
    * Constructor detail
    * @param iProvider
    * @param config
    * config param must be passed in as object:
    *  {
    *    refreshInterval: 120000,
    *    maxAge: 30000,
    *    restartDelay: 30000
    *  }
    */
    function FifoCache(iProvider) {
        var _this = _super.call(this, iProvider) || this;
        /**
         * @Override
         * key object mappings of the cache
         */
        _this.cacheEntries = {};
        /**
         * @Override
         * revalidate all cachd items
         */
        _this.revalidateCache = function () {
            // //this.log(FifoCache.TAG, 'revalidate', this.cacheEntries)
            var validator = _this.iProvider.itemValidator;
            try {
                for (var key in _this.cacheEntries) {
                    try {
                        validator.validate(_this.cacheEntries[key]);
                    }
                    catch (ex) {
                        //this.log(FifoCache.TAG, 'revalidate EX', ex)
                    }
                }
            }
            catch (exo) {
                //this.log(FifoCache.TAG, 'revalidate EXO', exo)
            }
        };
        return _this;
        //this.log(FifoCache.TAG, 'pid', this.settings.pid)
    }
    /**
     * @Override
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    FifoCache.prototype.start = function (params) {
        //this.log(FifoCache.TAG, 'start', params)
        this.settings = params;
        try {
            // make sure we're stopped
            this.stop();
            this.intervalMonitor =
                setInterval(this.revalidateCache, this.settings.refreshInterval);
        }
        catch (ex) {
            //this.log(FifoCache.TAG, 'error starting cache', ex.message)
            var st_1 = setTimeout(function () {
                clearTimeout(st_1);
            }, this.settings.restartDelay);
        }
    };
    /**
     * @Override
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    FifoCache.prototype.stop = function (params) {
        try {
            if (this.intervalMonitor !== null) {
                clearInterval(this.intervalMonitor);
                this.intervalMonitor = null;
            }
            //this.log(FifoCache.TAG, "stop done")
        }
        catch (ex) {
            //this.log(FifoCache.TAG, 'error stopping cache', ex.message)
        }
    };
    /**
     * @Override
     * return key -> object mapping of the whole cache
     */
    FifoCache.prototype.getItems = function () {
        return this.cacheEntries;
    };
    FifoCache.prototype.clearCache = function () {
        this.cacheEntries = {};
    };
    /**
     * @Override
     * return key -> object mapping of the whole cache
     * @param key
     */
    FifoCache.prototype.getItem = function (key) {
        if (!this.cacheEntries.hasOwnProperty(key)) {
            return null;
        }
        else {
            return this.cacheEntries[key];
        }
    };
    /**
     * @Override
     * add a new entry to the cache with or without associated object
     * and optional expiration time.
     * if the key already exists the itemValidator will patch it
     * @param key
     * @param item new data or not provided so we create a default
     * @param maxAge
     */
    FifoCache.prototype.addItem = function (key, item, maxAge) {
        maxAge = (typeof maxAge !== 'undefined') ? maxAge : this.settings.maxAge;
        item = (typeof item === 'undefined') ? { i: key } : item;
        if (!this.cacheEntries.hasOwnProperty(key)) {
            this.cacheEntries[key] =
                new Cacheable(key, item, this.iProvider.itemValidator.getNowMs(), maxAge);
            this.iProvider.refresh(this.cacheEntries[key]);
        }
        else {
            this.iProvider.itemValidator.
                patchItem(this.cacheEntries[key], item);
        }
    };
    /**
     * @Override
     * add a new entries to the cache with or without associated object
     * and optional expiration time
     * @param mappings
     * @param maxAge
     */
    FifoCache.prototype.addItems = function (mappings, maxAge) {
        maxAge = (typeof maxAge !== 'undefined') ? maxAge : this.settings.maxAge;
        for (var p in mappings) {
            this.addItem(p, mappings[p], maxAge);
        }
    };
    /**
     * @Override
     * remove a single cache entry
     * @param key
     */
    FifoCache.prototype.removeItem = function (key) {
        try {
            delete this.cacheEntries[key];
        }
        catch (ex) {
            return false;
        }
        return true;
    };
    /**
     * @Override
     * remove a list of cache entries
     * @param keys
     */
    FifoCache.prototype.removeItems = function (keys) {
        var _this = this;
        keys.map(function (k) {
            _this.removeItem(k);
        });
        return true;
    };
    /**
     * @Override
     * return all cache keys as array
     * @param mappings
     */
    FifoCache.prototype.asKeysArray = function (mappings) {
        var res = [];
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            res.push(p);
        }
        return res;
    };
    /**
     * @Override
     * return all cached objects as array
     * @param mappings
     */
    FifoCache.prototype.asObjectArray = function (mappings) {
        var res = [];
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            res.push(mappings[p]);
        }
        return res;
    };
    FifoCache.prototype.asKeysValueArray = function (mappings) {
        var res = {};
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            res[p] = this.cacheEntries[p].item;
        }
        return res;
    };
    /**
     * @Override
     * authenticate using the credentials from params
     * @param params must contain credentials in case process needs auth
     */
    FifoCache.prototype.auth = function (params) { };
    // log tag
    FifoCache.TAG = 'FifoCache';
    return FifoCache;
}(Process));
export { FifoCache };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/cache/fifo-cache.cls.ts
// module id = null
// module chunks = 